/* ===== block: hero ===== */
/* Block: hero (PLAN section 9, C3). The hero CTA and the sticky sub-nav CTA both
   scroll to the buy box, using the same contract as the cta block. The nav
   section links are plain anchors and need no script. */
(function () {
  window.NanoStory = window.NanoStory || { inits: {} };
  window.NanoStory.inits = window.NanoStory.inits || {};

  window.NanoStory.inits.hero = function (root) {
    if (!root || root.dataset.nsHeroReady === '1') return;
    root.dataset.nsHeroReady = '1';

    function prefersReducedMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function goToConfigurator(event) {
      var target = document.querySelector('bm-nano-configurator');
      if (event) event.preventDefault();
      if (!target || typeof target.scrollIntoView !== 'function') {
        window.scrollTo(0, 0);
        return;
      }
      target.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start'
      });
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      if (typeof target.focus === 'function') {
        try {
          target.focus({ preventScroll: true });
        } catch (err) {
          target.focus();
        }
      }
    }

    // The sticky nav is a sibling of the hero section, so collect its trigger too.
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-ns-hero-scroll]'));
    var nav = root.nextElementSibling;
    if (!(nav && nav.matches && nav.matches('[data-ns-hero-nav]'))) nav = null;
    if (nav) {
      triggers = triggers.concat(Array.prototype.slice.call(nav.querySelectorAll('[data-ns-hero-scroll]')));
    }
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', goToConfigurator);
    });

    // The theme header is not sticky: Dawn hides it on scroll down and brings it
    // back on scroll up, so a fixed `top` leaves a header-height gap above the bar
    // whenever the header is off-screen. Track the header's live bottom edge
    // instead, one write per animation frame.
    var HEADER_SELECTORS = ['sticky-header', 'header.header'];
    var pendingFrame = null;

    function headerBottom() {
      for (var i = 0; i < HEADER_SELECTORS.length; i++) {
        var el = document.querySelector(HEADER_SELECTORS[i]);
        if (el) return Math.max(0, Math.round(el.getBoundingClientRect().bottom));
      }
      return 0;
    }

    function syncNavTop() {
      pendingFrame = null;
      if (!root.isConnected) {
        window.removeEventListener('scroll', requestNavSync);
        window.removeEventListener('resize', requestNavSync);
        return;
      }
      if (!nav) return;
      var top = headerBottom() + 'px';
      if (nav.style.top !== top) nav.style.top = top;
    }

    function requestNavSync() {
      if (pendingFrame !== null) return;
      pendingFrame = window.requestAnimationFrame(syncNavTop);
    }

    if (nav) {
      window.addEventListener('scroll', requestNavSync, { passive: true });
      window.addEventListener('resize', requestNavSync);
      syncNavTop();
    }

    // Autoplay can be refused (power saving, reduced data). Fall back to the
    // poster rather than leaving a stalled first frame.
    Array.prototype.forEach.call(root.querySelectorAll('[data-ns-hero-video]'), function (video) {
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {
          video.controls = false;
        });
      }
    });
  };
})();

/* ===== block: peak ===== */
(function () {
  window.NanoStory = window.NanoStory || { inits: {} };

  window.NanoStory.inits.peak = function (root) {
    if (!root || root.dataset.nsPeakReady === 'true') return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-ns-peak-card]'));
    if (cards.length === 0) return;

    root.dataset.nsPeakReady = 'true';

    var cardsEl = root.querySelector('[data-ns-peak-cards]');
    var isTransitioning = false;
    var inView = false;

    function videoOf(card) {
      return card.querySelector('[data-ns-peak-video]');
    }

    function pauseCard(card) {
      var video = videoOf(card);
      if (video && typeof video.pause === 'function') video.pause();
    }

    function playCard(card) {
      var video = videoOf(card);
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      if (video.preload === 'none') video.preload = 'auto';
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(function () {});
    }

    function setActive(activeCard) {
      cards.forEach(function (card) {
        var isActive = card === activeCard;
        card.classList.toggle('is-active', isActive);
        card.setAttribute('aria-expanded', String(isActive));
        if (isActive && inView) {
          playCard(card);
        } else {
          pauseCard(card);
        }
      });
    }

    function activeIndex() {
      var index = cards.findIndex(function (card) {
        return card.classList.contains('is-active');
      });
      return index < 0 ? 0 : index;
    }

    function goTo(index) {
      if (isTransitioning) return;
      var clamped = Math.max(0, Math.min(cards.length - 1, index));
      isTransitioning = true;
      setActive(cards[clamped]);
      window.setTimeout(function () {
        isTransitioning = false;
      }, 240);
    }

    cards.forEach(function (card, index) {
      card.addEventListener('click', function () {
        goTo(index);
      });

      card.addEventListener('keydown', function (event) {
        var key = event.key;
        if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
          event.preventDefault();
          goTo(index);
          return;
        }
        if (key === 'ArrowRight' || key === 'ArrowDown') {
          event.preventDefault();
          var next = Math.min(cards.length - 1, index + 1);
          goTo(next);
          cards[next].focus();
          return;
        }
        if (key === 'ArrowLeft' || key === 'ArrowUp') {
          event.preventDefault();
          var prev = Math.max(0, index - 1);
          goTo(prev);
          cards[prev].focus();
          return;
        }
        if (key === 'Home') {
          event.preventDefault();
          goTo(0);
          cards[0].focus();
          return;
        }
        if (key === 'End') {
          event.preventDefault();
          goTo(cards.length - 1);
          cards[cards.length - 1].focus();
        }
      });
    });

    if (cardsEl && cards.length > 1) {
      var isDragging = false;
      var hasDragged = false;
      var dragStartX = 0;

      cardsEl.addEventListener('pointerdown', function (event) {
        if (isTransitioning) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        isDragging = true;
        hasDragged = false;
        dragStartX = event.clientX;
      });

      cardsEl.addEventListener('pointermove', function (event) {
        if (!isDragging || hasDragged) return;
        if (Math.abs(event.clientX - dragStartX) >= 5) hasDragged = true;
      });

      var stopDrag = function (event) {
        if (!isDragging) return;
        var delta = event.clientX - dragStartX;
        isDragging = false;
        if (hasDragged && Math.abs(delta) >= 24) {
          goTo(activeIndex() + (delta < 0 ? 1 : -1));
        }
        hasDragged = false;
      };

      cardsEl.addEventListener('pointerup', stopDrag);
      cardsEl.addEventListener('pointercancel', stopDrag);
    }

    var initial = cards.filter(function (card) {
      return card.classList.contains('is-active');
    })[0] || cards[0];
    setActive(initial);

    if (typeof window.IntersectionObserver === 'function') {
      var observer = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          var current = cards[activeIndex()];
          if (inView) {
            playCard(current);
          } else {
            cards.forEach(pauseCard);
          }
        });
      }, { threshold: 0.15 });
      observer.observe(root);
    } else {
      inView = true;
      playCard(cards[activeIndex()]);
    }
  };
})();

/* ===== block: modes ===== */
(function () {
  window.NanoStory = window.NanoStory || { inits: {} };
  window.NanoStory.inits = window.NanoStory.inits || {};

  window.NanoStory.inits.modes = function (root) {
    if (!root || root.dataset.nsModesReady === 'true') return;

    var viewport = root.querySelector('[data-ns-modes-viewport]');
    var track = root.querySelector('[data-ns-modes-track]');
    var cards = track ? Array.prototype.slice.call(track.querySelectorAll('[data-ns-modes-card]')) : [];
    var prevBtn = root.querySelector('[data-ns-modes-prev]');
    var nextBtn = root.querySelector('[data-ns-modes-next]');
    var controls = root.querySelector('[data-ns-modes-controls]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ns-modes-dot]'));

    if (!viewport || !track || cards.length === 0) return;
    root.dataset.nsModesReady = 'true';

    var activeIndex = 0;
    var currentX = 0;
    var cleanups = [];

    function on(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      cleanups.push(function () {
        target.removeEventListener(type, handler, options);
      });
    }

    function prefersReducedMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function setX(x, animate) {
      currentX = x;
      if (animate && !prefersReducedMotion()) {
        track.classList.add('is-animating');
      } else {
        track.classList.remove('is-animating');
      }
      track.style.setProperty('--ns-modes-x', x + 'px');
    }

    function hasOverflow() {
      return track.scrollWidth > viewport.clientWidth + 1;
    }

    function getBounds() {
      var minX = Math.min(0, viewport.clientWidth - track.scrollWidth);
      return { minX: minX, maxX: 0 };
    }

    function clamp(x, bounds) {
      var b = bounds || getBounds();
      return Math.max(b.minX, Math.min(b.maxX, x));
    }

    function getCardTargetX(card, bounds) {
      return clamp(-card.offsetLeft, bounds);
    }

    function getClosestIndex(x) {
      var bounds = getBounds();
      var closestIndex = 0;
      var closestDistance = Infinity;
      cards.forEach(function (card, index) {
        var distance = Math.abs(getCardTargetX(card, bounds) - x);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      return closestIndex;
    }

    function getDirectionalIndex(direction, x) {
      if (!direction) return getClosestIndex(x);
      var bounds = getBounds();
      var candidates = cards
        .map(function (card, index) {
          return { index: index, targetX: getCardTargetX(card, bounds) };
        })
        .filter(function (item) {
          return direction < 0 ? item.targetX <= x + 0.5 : item.targetX >= x - 0.5;
        });
      if (candidates.length === 0) return getClosestIndex(x);
      return candidates.reduce(function (closest, item) {
        return Math.abs(item.targetX - x) < Math.abs(closest.targetX - x) ? item : closest;
      }).index;
    }

    function setArrowDisabled(btn, disabled) {
      if (!btn) return;
      btn.disabled = disabled;
      btn.setAttribute('aria-disabled', String(disabled));
    }

    function updateDots() {
      dots.forEach(function (dot, index) {
        var active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function updateControls(x) {
      var scrollable = hasOverflow();
      root.classList.toggle('ns-modes--no-overflow', !scrollable);
      if (controls) {
        controls.hidden = !scrollable;
        controls.setAttribute('aria-hidden', String(!scrollable));
      }
      if (!scrollable) {
        setArrowDisabled(prevBtn, true);
        setArrowDisabled(nextBtn, true);
        return false;
      }
      var bounds = getBounds();
      setArrowDisabled(prevBtn, x >= bounds.maxX - 1);
      setArrowDisabled(nextBtn, x <= bounds.minX + 1);
      return true;
    }

    function setActive(index, animate) {
      activeIndex = Math.max(0, Math.min(cards.length - 1, index));
      updateDots();
      if (!hasOverflow()) {
        activeIndex = 0;
        updateDots();
        setX(0, false);
        updateControls(0);
        return;
      }
      var targetX = getCardTargetX(cards[activeIndex], getBounds());
      setX(targetX, animate !== false);
      updateControls(targetX);
    }

    function moveBy(direction) {
      if (!direction) return;
      setActive(activeIndex + direction, true);
    }

    function syncFromX(x) {
      activeIndex = getClosestIndex(x);
      updateDots();
      updateControls(x);
    }

    if (prevBtn) {
      on(prevBtn, 'click', function (event) {
        event.preventDefault();
        if (!prevBtn.disabled) moveBy(-1);
      });
    }

    if (nextBtn) {
      on(nextBtn, 'click', function (event) {
        event.preventDefault();
        if (!nextBtn.disabled) moveBy(1);
      });
    }

    dots.forEach(function (dot, index) {
      on(dot, 'click', function (event) {
        event.preventDefault();
        setActive(index, true);
      });
    });

    on(viewport, 'keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        moveBy(1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        moveBy(-1);
      } else if (event.key === 'Home') {
        event.preventDefault();
        setActive(0, true);
      } else if (event.key === 'End') {
        event.preventDefault();
        setActive(cards.length - 1, true);
      }
    });

    on(
      viewport,
      'wheel',
      function (event) {
        if (cards.length < 2 || !hasOverflow()) return;
        var deltaX = event.deltaX;
        if (event.deltaMode === 1) deltaX = event.deltaX * 16;
        else if (event.deltaMode === 2) deltaX = event.deltaX * viewport.clientWidth;
        if (Math.abs(deltaX) <= Math.abs(event.deltaY)) return;
        event.preventDefault();
        setX(clamp(currentX - deltaX), false);
        syncFromX(currentX);
      },
      { passive: false }
    );

    // Pointer drag
    var dragging = false;
    var pointerId = null;
    var startPointerX = 0;
    var startPointerY = 0;
    var startTrackX = 0;
    var axisLocked = false;

    function endDrag(event) {
      if (!dragging) return;
      dragging = false;
      axisLocked = false;
      viewport.classList.remove('is-dragging');
      if (pointerId !== null && viewport.releasePointerCapture) {
        try {
          viewport.releasePointerCapture(pointerId);
        } catch (e) {
          /* pointer already released */
        }
      }
      pointerId = null;
      var delta = currentX - startTrackX;
      var direction = Math.abs(delta) > 1 ? (delta > 0 ? 1 : -1) : 0;
      if (event) event.preventDefault();
      setActive(getDirectionalIndex(direction, currentX), true);
    }

    on(viewport, 'pointerdown', function (event) {
      if (event.button !== 0 && event.pointerType === 'mouse') return;
      if (!hasOverflow()) return;
      dragging = true;
      axisLocked = false;
      pointerId = event.pointerId;
      startPointerX = event.clientX;
      startPointerY = event.clientY;
      startTrackX = currentX;
      track.classList.remove('is-animating');
    });

    on(viewport, 'pointermove', function (event) {
      if (!dragging || event.pointerId !== pointerId) return;
      var dx = event.clientX - startPointerX;
      var dy = event.clientY - startPointerY;
      if (!axisLocked) {
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          dragging = false;
          pointerId = null;
          return;
        }
        axisLocked = true;
        viewport.classList.add('is-dragging');
        if (viewport.setPointerCapture) {
          try {
            viewport.setPointerCapture(event.pointerId);
          } catch (e) {
            /* capture unavailable */
          }
        }
      }
      event.preventDefault();
      setX(clamp(startTrackX + dx), false);
    });

    on(viewport, 'pointerup', endDrag);
    on(viewport, 'pointercancel', endDrag);
    on(viewport, 'lostpointercapture', endDrag);

    on(viewport, 'dragstart', function (event) {
      event.preventDefault();
    });

    on(viewport, 'click', function (event) {
      if (axisLocked) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    var resizeTimer = null;
    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        setActive(activeIndex, false);
      }, 150);
    }
    on(window, 'resize', onResize);

    root.nsModesDestroy = function () {
      window.clearTimeout(resizeTimer);
      cleanups.forEach(function (fn) {
        fn();
      });
      cleanups = [];
      delete root.dataset.nsModesReady;
    };

    setActive(0, false);
  };
})();

/* ===== block: feedback ===== */
(function () {
  window.NanoStory = window.NanoStory || { inits: {} };
  window.NanoStory.inits = window.NanoStory.inits || {};

  window.NanoStory.inits.feedback = function (root) {
    if (!root || root.dataset.nsFeedbackReady === 'true') return;
    root.dataset.nsFeedbackReady = 'true';

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-ns-feedback-step]'));
    var images = Array.prototype.slice.call(root.querySelectorAll('[data-ns-feedback-image]'));
    if (steps.length === 0) return;

    var maxIndex = steps.length - 1;
    var activeIndex = 0;
    var lastScrollY = window.scrollY || window.pageYOffset || 0;
    var ticking = false;

    function setActive(index) {
      var next = Math.min(Math.max(index, 0), maxIndex);
      activeIndex = next;
      steps.forEach(function (step, stepIndex) {
        var isActive = stepIndex === next;
        var isRevealed = stepIndex <= next;
        step.classList.toggle('is-active', isActive);
        step.classList.toggle('is-revealed', isRevealed);
        step.setAttribute('aria-expanded', String(isRevealed));
      });
      images.forEach(function (image, imageIndex) {
        image.classList.toggle('is-active', imageIndex === next);
      });
    }

    function stepPoint(step) {
      var marker = step.querySelector('.ns-feedback__number') || step;
      var rect = marker.getBoundingClientRect();
      return rect.top + rect.height / 2;
    }

    function scrollIndex(direction) {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var rootRect = root.getBoundingClientRect();
      if (rootRect.top >= viewportHeight) return 0;
      if (rootRect.bottom <= 0) return maxIndex;

      var triggerY = viewportHeight * 0.75;
      if (direction === 'up') {
        for (var i = maxIndex; i >= 0; i -= 1) {
          if (stepPoint(steps[i]) <= triggerY) return i;
        }
        return 0;
      }

      var index = 0;
      steps.forEach(function (step, stepIndex) {
        if (stepPoint(step) <= triggerY) index = stepIndex;
      });
      return index;
    }

    function updateFromScroll() {
      if (!root.isConnected) {
        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
        return;
      }
      var scrollY = window.scrollY || window.pageYOffset || 0;
      var direction = scrollY >= lastScrollY ? 'down' : 'up';
      lastScrollY = scrollY;
      setActive(scrollIndex(direction));
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        updateFromScroll();
      });
    }

    steps.forEach(function (step, index) {
      step.addEventListener('click', function () {
        setActive(index);
      });
    });

    var stepList = root.querySelector('[data-ns-feedback-steps]') || root;
    stepList.addEventListener('keydown', function (event) {
      var current = steps.indexOf(document.activeElement);
      if (current === -1) return;

      var target = null;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        target = Math.min(current + 1, maxIndex);
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        target = Math.max(current - 1, 0);
      } else if (event.key === 'Home') {
        target = 0;
      } else if (event.key === 'End') {
        target = maxIndex;
      }

      if (target === null || target === current) return;
      event.preventDefault();
      steps[target].focus();
      setActive(target);
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    setActive(0);
    requestUpdate();
  };
})();

/* ===== block: movements ===== */
(function () {
  window.NanoStory = window.NanoStory || { inits: {} };
  window.NanoStory.inits = window.NanoStory.inits || {};

  window.NanoStory.inits.movements = function (root) {
    if (!root || root.dataset.nsMovementsReady === 'true') return;

    var carousel = root.querySelector('[data-ns-movements-carousel]');
    var viewport = root.querySelector('[data-ns-movements-viewport]');
    var track = root.querySelector('[data-ns-movements-track]');
    if (!carousel || !viewport || !track) return;

    var sourceSlides = Array.prototype.slice.call(
      track.querySelectorAll('[data-ns-movements-slide]')
    );
    var total = sourceSlides.length;
    if (total === 0) return;

    root.dataset.nsMovementsReady = 'true';

    var prevBtn = root.querySelector('[data-ns-movements-arrow="prev"]');
    var nextBtn = root.querySelector('[data-ns-movements-arrow="next"]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ns-movements-dot]'));

    var TRANSITION_MS = 400;
    var DRAG_THRESHOLD = 24;
    var motionQuery =
      typeof window.matchMedia === 'function'
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : null;

    function reducedMotion() {
      return !!(motionQuery && motionQuery.matches);
    }

    /* ---- clone one set before and one set after for a seamless loop ---- */

    function buildSet() {
      var fragment = document.createDocumentFragment();
      sourceSlides.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.removeAttribute('data-ns-movements-slide');
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.nsMovementsClone = 'true';
        Array.prototype.slice.call(clone.querySelectorAll('a, button')).forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        Array.prototype.slice.call(clone.querySelectorAll('img')).forEach(function (img) {
          img.setAttribute('loading', 'lazy');
        });
        fragment.appendChild(clone);
      });
      return fragment;
    }

    track.insertBefore(buildSet(), track.firstChild);
    track.appendChild(buildSet());

    var slides = Array.prototype.slice.call(track.children);
    var index = total; /* first real slide */
    var settleTimer = null;

    function offsetOf(el) {
      if (!el) return 0;
      return el.getBoundingClientRect().left - track.getBoundingClientRect().left;
    }

    function currentX() {
      var transform = window.getComputedStyle(track).transform;
      if (!transform || transform === 'none') return 0;
      var match = transform.match(/matrix.*\((.+)\)/);
      if (!match) return 0;
      var parts = match[1].split(',').map(function (n) {
        return parseFloat(n);
      });
      return parts.length === 6 ? parts[4] : parts[12];
    }

    function setX(x, animate) {
      track.style.transition = animate && !reducedMotion() ? 'transform ' + TRANSITION_MS + 'ms ease' : 'none';
      track.style.transform = 'translateX(' + x + 'px)';
    }

    function realIndex() {
      return ((index % total) + total) % total;
    }

    function updateDots() {
      var active = realIndex();
      dots.forEach(function (dot, i) {
        var isActive = i === active;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        dot.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }

    function position(animate) {
      setX(-offsetOf(slides[index]), animate);
      updateDots();
    }

    function normalize() {
      if (index >= total * 2) index -= total;
      else if (index < total) index += total;
      position(false);
    }

    function goTo(next) {
      index = next;
      position(true);
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(normalize, TRANSITION_MS + 40);
    }

    function step(direction) {
      stopAutoplay();
      goTo(index + direction);
      startAutoplay();
    }

    /* ---- autoplay ---- */

    var autoplayEnabled = carousel.dataset.nsMovementsAutoplay !== 'false' && total > 1;
    var autoplayInterval = parseInt(carousel.dataset.nsMovementsAutoplayInterval || '4000', 10);
    var autoplayTimer = null;
    var paused = false;

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || paused || reducedMotion()) return;
      autoplayTimer = window.setInterval(function () {
        if (document.hidden) return;
        goTo(index + 1);
      }, autoplayInterval);
    }

    function pause() {
      paused = true;
      stopAutoplay();
    }

    function resume() {
      paused = false;
      startAutoplay();
    }

    carousel.addEventListener('mouseenter', pause);
    carousel.addEventListener('mouseleave', resume);
    carousel.addEventListener('focusin', pause);
    carousel.addEventListener('focusout', function (event) {
      if (!carousel.contains(event.relatedTarget)) resume();
    });

    /* ---- controls ---- */

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        step(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        step(1);
      });
    }

    function goToDot(dotIndex) {
      var offset = dotIndex - realIndex();
      if (offset === 0) return;
      stopAutoplay();
      goTo(index + offset);
      startAutoplay();
    }

    dots.forEach(function (dot, i) {
      dot.setAttribute('tabindex', i === 0 ? '0' : '-1');
      dot.addEventListener('click', function () {
        goToDot(i);
      });
      dot.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % dots.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + dots.length) % dots.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = dots.length - 1;
        if (next === null) return;
        event.preventDefault();
        goToDot(next);
        dots[next].focus();
      });
    });

    viewport.addEventListener('keydown', function (event) {
      if (event.target !== viewport) return;
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        step(1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        step(-1);
      } else if (event.key === 'Home') {
        event.preventDefault();
        stopAutoplay();
        goTo(index - realIndex());
        startAutoplay();
      } else if (event.key === 'End') {
        event.preventDefault();
        stopAutoplay();
        goTo(index + (total - 1 - realIndex()));
        startAutoplay();
      }
    });

    /* ---- pointer drag ---- */

    var dragging = false;
    var hasMoved = false;
    var startPointerX = 0;
    var startTrackX = 0;
    var activePointer = null;

    function slideStep() {
      var first = slides[index] || slides[0];
      var second = slides[index + 1] || slides[1];
      if (first && second) {
        var delta = offsetOf(second) - offsetOf(first);
        if (delta > 0) return delta;
      }
      return first ? first.getBoundingClientRect().width : viewport.clientWidth;
    }

    viewport.addEventListener('pointerdown', function (event) {
      if (total < 2) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      hasMoved = false;
      activePointer = event.pointerId;
      startPointerX = event.clientX;
      window.clearTimeout(settleTimer);
      startTrackX = currentX();
      pause();
      setX(startTrackX, false);
      if (viewport.setPointerCapture) viewport.setPointerCapture(event.pointerId);
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!dragging || event.pointerId !== activePointer) return;
      var delta = event.clientX - startPointerX;
      if (!hasMoved && Math.abs(delta) < 5) return;
      if (!hasMoved) {
        hasMoved = true;
        carousel.classList.add('is-dragging');
      }
      if (event.cancelable) event.preventDefault();
      var limit = slideStep() * 1.5;
      var clamped = Math.max(-limit, Math.min(limit, delta));
      setX(startTrackX + clamped, false);
    });

    function endDrag(event) {
      if (!dragging || (activePointer !== null && event.pointerId !== activePointer)) return;
      var delta = event.clientX - startPointerX;
      dragging = false;
      activePointer = null;
      if (viewport.releasePointerCapture && event.pointerId !== undefined) {
        try {
          viewport.releasePointerCapture(event.pointerId);
        } catch (e) {
          /* pointer already released */
        }
      }
      if (hasMoved) {
        carousel.classList.remove('is-dragging');
        if (Math.abs(delta) >= DRAG_THRESHOLD) {
          var steps = Math.round(-delta / slideStep());
          if (steps === 0) steps = delta < 0 ? 1 : -1;
          goTo(index + steps);
        } else {
          position(true);
        }
      }
      hasMoved = false;
      resume();
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    /* ---- resize ---- */

    var resizeTimer = null;
    var resizeHandler = function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        position(false);
      }, 150);
    };

    if (typeof window.ResizeObserver === 'function') {
      var observer = new window.ResizeObserver(resizeHandler);
      observer.observe(viewport);
    }

    if (motionQuery && typeof motionQuery.addEventListener === 'function') {
      motionQuery.addEventListener('change', function () {
        if (reducedMotion()) stopAutoplay();
        else startAutoplay();
      });
    }

    position(false);
    updateDots();
    startAutoplay();
  };
})();

/* ===== block: personas ===== */
/* Block: personas (port of supplier nano_peak_aU7UVH / nano-peak.js)
   Expanding persona cards: click, keyboard, pointer drag, and mobile
   activate-on-scroll. Registered on window.NanoStory.inits.personas. */
(function () {
  window.NanoStory = window.NanoStory || { inits: {} };
  window.NanoStory.inits = window.NanoStory.inits || {};

  window.NanoStory.inits.personas = function (root) {
    if (!root || root.dataset.nsPersonasReady === 'true') return;

    var cards = Array.prototype.slice.call(
      root.querySelectorAll('[data-ns-personas-card]')
    );
    if (cards.length === 0) return;

    root.dataset.nsPersonasReady = 'true';

    var cardsEl = root.querySelector('[data-ns-personas-cards]');
    var mobileQuery = window.matchMedia('(max-width: 1024px)');
    var isTransitioning = false;
    var isDragging = false;
    var hasDragged = false;
    var dragStartX = 0;
    var observer = null;

    function setActiveCard(activeCard) {
      cards.forEach(function (card) {
        var isActive = card === activeCard;
        card.classList.toggle('is-active', isActive);
        card.setAttribute('aria-expanded', String(isActive));
      });
    }

    function activeIndex() {
      for (var i = 0; i < cards.length; i += 1) {
        if (cards[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function goTo(index, moveFocus) {
      if (isTransitioning) return;
      var clamped = Math.max(0, Math.min(cards.length - 1, index));
      isTransitioning = true;
      setActiveCard(cards[clamped]);
      if (moveFocus) cards[clamped].focus();
      window.setTimeout(function () {
        isTransitioning = false;
      }, 240);
    }

    cards.forEach(function (card, index) {
      card.addEventListener('click', function () {
        goTo(index, false);
      });

      card.addEventListener('keydown', function (event) {
        var key = event.key;
        if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
          event.preventDefault();
          goTo(index, false);
          return;
        }
        if (key === 'ArrowRight' || key === 'ArrowDown') {
          event.preventDefault();
          goTo(index + 1, true);
          return;
        }
        if (key === 'ArrowLeft' || key === 'ArrowUp') {
          event.preventDefault();
          goTo(index - 1, true);
          return;
        }
        if (key === 'Home') {
          event.preventDefault();
          goTo(0, true);
          return;
        }
        if (key === 'End') {
          event.preventDefault();
          goTo(cards.length - 1, true);
        }
      });
    });

    if (cardsEl) {
      cardsEl.addEventListener('pointerdown', function (event) {
        if (cards.length < 2 || isTransitioning) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        isDragging = true;
        hasDragged = false;
        dragStartX = event.clientX;
      });

      cardsEl.addEventListener('pointermove', function (event) {
        if (!isDragging || hasDragged) return;
        if (Math.abs(event.clientX - dragStartX) >= 5) hasDragged = true;
      });

      var stopDrag = function (event) {
        if (!isDragging) return;
        var delta = event.clientX - dragStartX;
        isDragging = false;
        if (hasDragged && Math.abs(delta) >= 24) {
          goTo(activeIndex() + (delta < 0 ? 1 : -1), false);
        }
        hasDragged = false;
      };

      cardsEl.addEventListener('pointerup', stopDrag);
      cardsEl.addEventListener('pointercancel', stopDrag);
    }

    /* Mobile: the card crossing the 60% viewport line becomes active.
       Uses IntersectionObserver so there is no document or window listener. */
    function startObserver() {
      if (observer || typeof window.IntersectionObserver !== 'function') return;
      observer = new window.IntersectionObserver(
        function (entries) {
          if (!mobileQuery.matches) return;
          var candidate = null;
          entries.forEach(function (entry) {
            if (entry.isIntersecting) candidate = entry.target;
          });
          if (candidate && !candidate.classList.contains('is-active')) {
            setActiveCard(candidate);
          }
        },
        { rootMargin: '-60% 0px -39% 0px', threshold: 0 }
      );
      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    function stopObserver() {
      if (!observer) return;
      observer.disconnect();
      observer = null;
    }

    function syncViewport() {
      if (mobileQuery.matches) startObserver();
      else stopObserver();
    }

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncViewport);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(syncViewport);
    }

    var initial = cards.filter(function (card) {
      return card.classList.contains('is-active');
    })[0] || cards[0];
    setActiveCard(initial);
    syncViewport();
  };
})();

/* ===== block: choose ===== */
(function () {
  window.NanoStory = window.NanoStory || { inits: {} };
  window.NanoStory.inits = window.NanoStory.inits || {};

  window.NanoStory.inits.choose = function (root) {
    if (!root || root.dataset.nsChooseReady === 'true') return;

    var scope = root.querySelector('[data-ns-choose]') || root;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ns-choose-tab]'));
    if (!tabs.length) return;

    root.dataset.nsChooseReady = 'true';

    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ns-choose-panel]'));
    var details = Array.prototype.slice.call(root.querySelectorAll('[data-ns-choose-detail]'));
    var tabScroll = root.querySelector('[data-ns-choose-tab-scroll]');
    var tabViewport = root.querySelector('[data-ns-choose-tab-viewport]');
    var tabList = root.querySelector('[data-ns-choose-tabs]');
    var prevBtn = root.querySelector('[data-ns-choose-tab-prev]');
    var nextBtn = root.querySelector('[data-ns-choose-tab-next]');
    var packHandle = scope.dataset.nsChoosePackHandle || '';

    var hideTimers = new WeakMap();
    var minX = 0;
    var currentX = 0;
    var activeIndex = 0;

    function clampX(x) {
      return Math.max(minX, Math.min(0, x));
    }

    function viewportContentWidth() {
      if (!tabViewport) return 0;
      var style = window.getComputedStyle(tabViewport);
      var padding = parseFloat(style.paddingLeft || '0') + parseFloat(style.paddingRight || '0');
      return tabViewport.clientWidth - padding;
    }

    function updateTabOverflow() {
      if (!tabScroll) return;
      var hasOverflow = minX < 0;
      tabScroll.classList.toggle('is-overflowing', hasOverflow);
      tabScroll.classList.toggle('has-overflow-left', hasOverflow && currentX < -1);
      tabScroll.classList.toggle('has-overflow-right', hasOverflow && currentX > minX + 1);
    }

    function setTabX(x, animate) {
      if (!tabList) return;
      currentX = clampX(x);
      tabList.style.transition = animate ? 'transform 320ms ease' : 'none';
      tabList.style.transform = 'translate3d(' + currentX + 'px, 0, 0)';
      updateTabOverflow();
    }

    function refreshTabDrag() {
      if (!tabViewport || !tabList) return;
      var overflow = tabList.scrollWidth - viewportContentWidth();
      minX = overflow > 1 ? -overflow : 0;
      setTabX(minX === 0 ? 0 : currentX, false);
    }

    function centerTab(tab, animate) {
      if (!tab || !tabViewport) return;
      setTabX(-(tab.offsetLeft + tab.offsetWidth / 2 - viewportContentWidth() / 2), animate);
    }

    function reveal(items, index) {
      items.forEach(function (item, itemIndex) {
        var active = itemIndex === index;
        var timer = hideTimers.get(item);
        if (timer) {
          window.clearTimeout(timer);
          hideTimers.delete(item);
        }
        if (active) {
          item.hidden = false;
          window.requestAnimationFrame(function () {
            item.classList.add('is-active');
          });
          return;
        }
        item.classList.remove('is-active');
        hideTimers.set(
          item,
          window.setTimeout(function () {
            if (!item.classList.contains('is-active')) item.hidden = true;
            hideTimers.delete(item);
          }, 280)
        );
      });
    }

    // Tabs the customer can actually reach right now. A Dual tab that the open
    // batch cannot cover is taken out of the rail, so it must also drop out of
    // keyboard navigation and out of any fallback.
    function visibleTabs() {
      return tabs.filter(function (tab) {
        return tab.parentNode === tabList;
      });
    }

    function setActive(index, shouldScroll) {
      if (index < 0 || index > tabs.length - 1) return;
      if (tabs[index].parentNode !== tabList) return;
      activeIndex = index;
      tabs.forEach(function (tab, tabIndex) {
        var active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) {
          tab.removeAttribute('tabindex');
        } else {
          tab.setAttribute('tabindex', '-1');
        }
      });
      reveal(panels, index);
      reveal(details, index);
      if (shouldScroll !== false) {
        centerTab(tabs[index], true);
        window.setTimeout(refreshTabDrag, 320);
      }
    }

    var drag = {
      pointerId: null,
      startX: 0,
      startTranslate: 0,
      targetTab: null,
      dragging: false,
      suppressClick: false
    };

    function clearSuppressClick() {
      drag.suppressClick = false;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        if (drag.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        var index = parseInt(tab.dataset.nsChooseTab || '0', 10);
        if (isFinite(index)) setActive(index, true);
      });
    });

    if (tabList) {
      tabList.addEventListener('keydown', function (event) {
        var reachable = visibleTabs();
        if (!reachable.length) return;
        var here = reachable.indexOf(tabs[activeIndex]);
        if (here < 0) here = 0;
        var step = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') step = here + 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') step = here - 1;
        else if (event.key === 'Home') step = 0;
        else if (event.key === 'End') step = reachable.length - 1;
        if (step === null) return;
        if (step < 0) step = reachable.length - 1;
        if (step > reachable.length - 1) step = 0;
        event.preventDefault();
        var target = reachable[step];
        var next = parseInt(target.dataset.nsChooseTab || '0', 10);
        if (!isFinite(next)) return;
        setActive(next, true);
        target.focus();
      });
    }

    if (tabViewport) {
      tabViewport.addEventListener('pointerdown', function (event) {
        if (minX === 0) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        drag.pointerId = event.pointerId;
        drag.startX = event.clientX;
        drag.startTranslate = currentX;
        drag.targetTab = event.target.closest ? event.target.closest('[data-ns-choose-tab]') : null;
        drag.dragging = false;
        drag.suppressClick = false;
        if (tabList) tabList.style.transition = 'none';
        if (tabViewport.setPointerCapture) tabViewport.setPointerCapture(event.pointerId);
      });

      tabViewport.addEventListener('pointermove', function (event) {
        if (drag.pointerId !== event.pointerId) return;
        var deltaX = event.clientX - drag.startX;
        if (!drag.dragging && Math.abs(deltaX) > 6) {
          drag.dragging = true;
          drag.suppressClick = true;
        }
        if (drag.dragging) {
          setTabX(drag.startTranslate + deltaX, false);
          event.preventDefault();
        }
      });

      var endDrag = function (event) {
        if (drag.pointerId !== event.pointerId) return;
        if (tabViewport.hasPointerCapture && tabViewport.hasPointerCapture(event.pointerId)) {
          tabViewport.releasePointerCapture(event.pointerId);
        }
        drag.pointerId = null;
        if (drag.dragging) {
          setTabX(currentX, false);
          window.setTimeout(clearSuppressClick, 80);
        } else if (drag.targetTab) {
          var index = parseInt(drag.targetTab.dataset.nsChooseTab || '0', 10);
          if (isFinite(index)) setActive(index, true);
          drag.suppressClick = true;
          window.setTimeout(clearSuppressClick, 80);
        } else {
          drag.suppressClick = false;
        }
        drag.targetTab = null;
        drag.dragging = false;
      };

      tabViewport.addEventListener('pointerup', endDrag);
      tabViewport.addEventListener('pointercancel', endDrag);
      tabViewport.addEventListener('lostpointercapture', function () {
        drag.pointerId = null;
        drag.targetTab = null;
        drag.dragging = false;
        window.setTimeout(clearSuppressClick, 80);
      });

      tabViewport.addEventListener(
        'wheel',
        function (event) {
          if (minX === 0) return;
          var deltaX = event.deltaX;
          if (event.deltaMode === 1) deltaX = event.deltaX * 16;
          else if (event.deltaMode === 2) deltaX = event.deltaX * tabViewport.clientWidth;
          if (Math.abs(deltaX) <= Math.abs(event.deltaY)) return;
          event.preventDefault();
          setTabX(currentX - deltaX, false);
        },
        { passive: false }
      );
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (!tabViewport) return;
        setTabX(currentX + tabViewport.clientWidth * 0.65, true);
        window.setTimeout(refreshTabDrag, 320);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!tabViewport) return;
        setTabX(currentX - tabViewport.clientWidth * 0.65, true);
        window.setTimeout(refreshTabDrag, 320);
      });
    }

    /* ---------- Select buttons: drive the buy box ---------- */

    function scrollToBuyBox() {
      var box = document.querySelector('bm-nano-configurator');
      if (box && typeof box.scrollIntoView === 'function') {
        box.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return box;
      }
      window.scrollTo(0, 0);
      return null;
    }

    function packCheckbox() {
      if (!packHandle) return null;
      return document.querySelector(
        '.gm2ax__row[data-handle="' + packHandle + '"] .gm2ax__cb'
      );
    }

    function tickPack() {
      var cb = packCheckbox();
      if (!cb || cb.disabled) return false;
      if (!cb.checked) {
        cb.checked = true;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }

    function buyBox() {
      var api = window.BMNano;
      if (!api || typeof api.setQuantity !== 'function' || typeof api.available !== 'function') return null;
      return api;
    }

    function applySelection(mount, withPack, qty, attemptsLeft) {
      var api = buyBox();
      // A two-unit preset commits nothing until it can actually set the
      // quantity. Choosing the mount first and failing on the quantity would
      // leave the shopper on one unit having clicked a two-unit card.
      if (qty > 1 && !api) {
        if (attemptsLeft > 0) {
          window.setTimeout(function () {
            applySelection(mount, withPack, qty, attemptsLeft - 1);
          }, 150);
        }
        return;
      }
      var box = document.querySelector('bm-nano-configurator');
      var host = box || document;
      var button = host.querySelector('button[data-mount="' + mount + '"]');
      var mountDone = false;
      if (button) {
        if (button.getAttribute('aria-pressed') !== 'true') button.click();
        mountDone = true;
      }
      // Always after the mount click, never before: committing a mount drops
      // the quantity back to one unit, so a preset set first would be lost.
      var qtyDone = false;
      if (api) {
        api.setQuantity(qty);
        qtyDone = true;
      }
      var packDone = !withPack || tickPack();
      if ((mountDone && qtyDone && packDone) || attemptsLeft <= 0) return;
      window.setTimeout(function () {
        applySelection(mount, withPack, qty, attemptsLeft - 1);
      }, 150);
    }

    Array.prototype.slice
      .call(root.querySelectorAll('[data-ns-choose-select]'))
      .forEach(function (button) {
        button.addEventListener('click', function () {
          var mount = button.dataset.nsChooseSelect || 'slide';
          var withPack = button.dataset.nsChoosePack === 'true';
          var qty = parseInt(button.dataset.nsChooseQty || '1', 10);
          if (!isFinite(qty) || qty < 1) qty = 1;
          scrollToBuyBox();
          applySelection(mount, withPack, qty, 20);
        });
      });

    /* ---------- Dual presets: offer them only when the batch covers two ---------- */

    var dualTabs = tabs.filter(function (tab) {
      return tab.hasAttribute('data-ns-choose-dual');
    });
    var dualShown = null;

    // The allocation panel shows HALF the remaining allocation, rounded down,
    // so a displayed integer of 1 already means at least two real units. The
    // no-number "final units" state carries no count and may be a single unit,
    // which is exactly why an absent .bma-n must read as "not enough".
    function batchCoversTwo() {
      var panel = document.querySelector('[data-bm-allocation]');
      if (!panel || panel.hasAttribute('hidden')) return false;
      var node = panel.querySelector('.bma-n');
      if (!node) return false;
      var digits = String(node.textContent || '').replace(/[^0-9]/g, '');
      if (!digits) return false;
      var left = parseInt(digits, 10);
      return isFinite(left) && left >= 1;
    }

    // Three-state on purpose. null means "the buy box has not booted yet", and
    // that is not the same as "no": treating it as no would tear the cards out
    // of the page and put them back a moment later. Once the buy box is there,
    // no way to post two units means the preset is not offered at all, rather
    // than a Dual card that quietly adds one.
    function dualDecision() {
      var api = buyBox();
      if (!api) return null;
      if (!api.available('slide')) return false;
      return batchCoversTwo();
    }

    // Where each Dual node sits when it is offered, captured before anything
    // moves, so taking it out and putting it back are exact inverses. A Dual
    // Select button that is merely hidden is still a two-unit Select button in
    // the page; on a store whose batch cannot cover two units it must not be
    // there at all.
    var dualAnchors = [];
    [[tabs, false], [details, true], [panels, true]].forEach(function (entry) {
      entry[0].forEach(function (node) {
        if (!node.hasAttribute('data-ns-choose-dual')) return;
        dualAnchors.push({ node: node, parent: node.parentNode, next: node.nextSibling, panel: entry[1] });
      });
    });

    function applyDual(allowed) {
      // Fall back first, while every node is still connected, so the reveal
      // pass runs over the panels it is actually describing.
      if (!allowed && tabs[activeIndex] && tabs[activeIndex].hasAttribute('data-ns-choose-dual')) {
        setActive(0, false);
      }
      if (allowed) {
        // Back to front: a Dual node's recorded neighbour may itself be a Dual
        // node, which has to be in place first for insertBefore to land right.
        for (var i = dualAnchors.length - 1; i >= 0; i--) {
          var anchor = dualAnchors[i];
          if (anchor.node.parentNode === anchor.parent) continue;
          // A restored Dual panel is never the active one (the fallback moved
          // the selection to the first card before it was taken out), so it
          // comes back closed rather than transparent-but-clickable.
          if (anchor.panel) anchor.node.hidden = true;
          anchor.parent.insertBefore(
            anchor.node,
            anchor.next && anchor.next.parentNode === anchor.parent ? anchor.next : null
          );
        }
      } else {
        dualAnchors.forEach(function (anchor) {
          anchor.node.classList.remove('is-active');
          if (anchor.node.parentNode) anchor.node.parentNode.removeChild(anchor.node);
        });
      }
      refreshTabDrag();
    }

    // The panel fires no event of its own, so watch the node: it swaps its card
    // markup wholesale, rewrites the number in place, and toggles its own
    // hidden flag. Re-attaches if the panel is ever replaced.
    var watchedPanel = null;
    function watchAllocation() {
      if (typeof MutationObserver !== 'function') return;
      var panel = document.querySelector('[data-bm-allocation]');
      if (!panel || panel === watchedPanel) return;
      watchedPanel = panel;
      new MutationObserver(syncDual).observe(panel, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['hidden']
      });
    }

    var dualDeadline = Date.now() + 8000;

    function syncDual() {
      if (!dualTabs.length) return;
      watchAllocation();
      var decision = dualDecision();
      if (decision === null) {
        // Still undecided. Past the deadline, undecided becomes no: a Dual card
        // with no buy box to drive cannot be allowed to stand indefinitely.
        if (Date.now() < dualDeadline) return;
        decision = false;
      }
      if (decision === dualShown) return;
      dualShown = decision;
      applyDual(decision);
    }

    if (dualTabs.length) {
      syncDual();
      // The buy box upgrades its custom element and the allocation panel paints
      // on its own schedule, so re-read for a few seconds after boot.
      [250, 700, 1500, 3000, 6000, 8500].forEach(function (ms) {
        window.setTimeout(syncDual, ms);
      });
      // The same event the allocation panel repaints on, read after its own
      // two-frame settle so we see the number it just wrote, not the old one.
      document.addEventListener('change', function (event) {
        var target = event && event.target;
        if (!target || target.name !== 'id') return;
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(syncDual);
        });
        window.setTimeout(syncDual, 250);
      });
    }

    /* ---------- Boot ---------- */

    var parsedDefault = parseInt(scope.dataset.nsChooseDefault || '0', 10);
    var defaultIndex = isFinite(parsedDefault)
      ? Math.max(0, Math.min(tabs.length - 1, parsedDefault))
      : 0;

    setActive(defaultIndex, false);
    refreshTabDrag();
    centerTab(tabs[defaultIndex], false);
    window.requestAnimationFrame(refreshTabDrag);
    window.setTimeout(refreshTabDrag, 80);

    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(refreshTabDrag).catch(function () {});
    }

    if (typeof ResizeObserver === 'function' && tabViewport) {
      var observer = new ResizeObserver(function () {
        refreshTabDrag();
      });
      observer.observe(tabViewport);
      if (tabList) observer.observe(tabList);
    }
  };
})();

/* ===== block: accessories ===== */
(function () {
  window.NanoStory = window.NanoStory || { inits: {} };

  window.NanoStory.inits.accessories = function (root) {
    if (!root || root.dataset.nsAccessoriesReady === 'true') return;

    var viewport = root.querySelector('[data-ns-accessories-viewport]');
    var grid = root.querySelector('[data-ns-accessories-grid]');
    if (!viewport || !grid) return;

    root.dataset.nsAccessoriesReady = 'true';

    var MOBILE_QUERY = '(max-width: 1024px)';
    var mediaQuery = window.matchMedia(MOBILE_QUERY);
    var minX = 0;
    var currentX = 0;
    var resizeTimer = null;
    var drag = { pointerId: null, startX: 0, startTranslate: 0, dragging: false, suppressClick: false };

    function clampX(x) {
      return Math.max(minX, Math.min(0, x));
    }

    function setX(x, animate) {
      if (!mediaQuery.matches) {
        currentX = 0;
        grid.style.transition = '';
        grid.style.transform = '';
        return;
      }
      currentX = clampX(x);
      grid.style.transition = animate ? 'transform 320ms ease' : 'none';
      grid.style.transform = 'translate3d(' + currentX + 'px, 0, 0)';
    }

    function step() {
      var card = grid.querySelector('.ns-accessories__card');
      var width = card ? card.getBoundingClientRect().width : 144;
      var styles = window.getComputedStyle(grid);
      var gap = parseFloat(styles.columnGap || styles.gap || '12');
      if (isNaN(gap)) gap = 12;
      return width + gap;
    }

    function refresh() {
      if (!mediaQuery.matches) {
        setX(0, false);
        return;
      }
      var vpStyle = window.getComputedStyle(viewport);
      var padding = parseFloat(vpStyle.paddingLeft || '0') + parseFloat(vpStyle.paddingRight || '0');
      var visible = viewport.clientWidth - (isNaN(padding) ? 0 : padding);
      var overflow = grid.scrollWidth - visible;
      minX = overflow > 1 ? -overflow : 0;
      setX(minX === 0 ? 0 : currentX, false);
    }

    function normalizeWheelDelta(event) {
      if (event.deltaMode === 1) return event.deltaX * 16;
      if (event.deltaMode === 2) return event.deltaX * viewport.clientWidth;
      return event.deltaX;
    }

    function clearSuppressClick() {
      drag.suppressClick = false;
    }

    viewport.addEventListener('pointerdown', function (event) {
      if (!mediaQuery.matches || minX === 0) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      drag.pointerId = event.pointerId;
      drag.startX = event.clientX;
      drag.startTranslate = currentX;
      drag.dragging = false;
      drag.suppressClick = false;
      grid.style.transition = 'none';
      if (viewport.setPointerCapture) viewport.setPointerCapture(event.pointerId);
    });

    viewport.addEventListener('pointermove', function (event) {
      if (drag.pointerId !== event.pointerId) return;
      var deltaX = event.clientX - drag.startX;
      if (!drag.dragging && Math.abs(deltaX) > 6) {
        drag.dragging = true;
        drag.suppressClick = true;
      }
      if (drag.dragging) {
        setX(drag.startTranslate + deltaX, false);
        event.preventDefault();
      }
    });

    function endDrag(event) {
      if (drag.pointerId !== event.pointerId) return;
      if (viewport.hasPointerCapture && viewport.hasPointerCapture(event.pointerId)) {
        viewport.releasePointerCapture(event.pointerId);
      }
      drag.pointerId = null;
      if (drag.dragging) {
        setX(currentX, false);
        window.setTimeout(clearSuppressClick, 80);
      } else {
        drag.suppressClick = false;
      }
      drag.dragging = false;
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('lostpointercapture', function () {
      drag.pointerId = null;
      drag.dragging = false;
      window.setTimeout(clearSuppressClick, 80);
    });

    grid.addEventListener(
      'click',
      function (event) {
        if (drag.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    viewport.addEventListener(
      'wheel',
      function (event) {
        if (!mediaQuery.matches || minX === 0) return;
        var deltaX = normalizeWheelDelta(event);
        if (Math.abs(deltaX) <= Math.abs(event.deltaY)) return;
        event.preventDefault();
        setX(currentX - deltaX, false);
      },
      { passive: false }
    );

    viewport.addEventListener('keydown', function (event) {
      if (!mediaQuery.matches || minX === 0) return;
      var key = event.key;
      if (key === 'ArrowRight') {
        event.preventDefault();
        setX(currentX - step(), true);
      } else if (key === 'ArrowLeft') {
        event.preventDefault();
        setX(currentX + step(), true);
      } else if (key === 'Home') {
        event.preventDefault();
        setX(0, true);
      } else if (key === 'End') {
        event.preventDefault();
        setX(minX, true);
      }
    });

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refresh, 120);
    });

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', refresh);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(refresh);
    }

    Array.prototype.forEach.call(grid.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', refresh, { once: true });
    });

    refresh();
    window.requestAnimationFrame(refresh);
    window.setTimeout(refresh, 80);
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(refresh).catch(function () {});
    }
  };
})();

/* ===== block: cta ===== */
(function () {
  window.NanoStory = window.NanoStory || { inits: {} };
  window.NanoStory.inits = window.NanoStory.inits || {};

  window.NanoStory.inits.cta = function (root) {
    if (!root || root.dataset.nsCtaReady === '1') return;
    root.dataset.nsCtaReady = '1';

    var trigger = root.querySelector('[data-ns-cta-scroll]');
    if (!trigger) return;

    function prefersReducedMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function goToConfigurator(event) {
      var target = document.querySelector('bm-nano-configurator');

      if (!target || typeof target.scrollIntoView !== 'function') {
        if (event) event.preventDefault();
        window.scrollTo(0, 0);
        return;
      }

      if (event) event.preventDefault();

      target.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start'
      });

      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      if (typeof target.focus === 'function') {
        try {
          target.focus({ preventScroll: true });
        } catch (err) {
          target.focus();
        }
      }
    }

    trigger.addEventListener('click', goToConfigurator);
  };
})();

/* --------------------------------------------------------------------------
   nano-story bootstrap: run every block init inside every story root, once on
   load and again whenever the theme editor reloads the section.
   -------------------------------------------------------------------------- */
(function () {
  window.NanoStory = window.NanoStory || { inits: {} };
  window.NanoStory.inits = window.NanoStory.inits || {};

  function initBlocks(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    var blocks = root.querySelectorAll('[data-ns-block]');
    Array.prototype.forEach.call(blocks, function (block) {
      var name = block.getAttribute('data-ns-block');
      var init = name ? window.NanoStory.inits[name] : null;
      if (typeof init !== 'function') return;
      try {
        init(block);
      } catch (error) {
        if (window.console && typeof window.console.warn === 'function') {
          window.console.warn('nano-story: init failed for block "' + name + '"', error);
        }
      }
    });
  }

  function initScope(scope) {
    var container = scope && typeof scope.querySelectorAll === 'function' ? scope : document;
    if (container !== document && typeof container.matches === 'function' && container.matches('[data-nano-story]')) {
      initBlocks(container);
    }
    Array.prototype.forEach.call(container.querySelectorAll('[data-nano-story]'), initBlocks);
  }

  function boot() {
    initScope(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initScope(event && event.target ? event.target : document);
  });
})();
